<template>
	<div class="forget">
		<div class="logo" @click="toHome">
			<img src="../../assets/images/icon/logo.png" alt="">
		</div>
		<div class="first_title">Reset Password</div>
		<div class="content">
			<div class="item">
				<input type="text" v-model="email" placeholder="Email">
			</div>
			<div class="code_box flex align-center justify-between">
				<input type="text" placeholder="Verification code" v-model="code">
				<div class="code" @click="getCode">{{codeStatus ? codeNub : 'Send Code'}}</div>
			</div>
			<div class="item">
				<input type="text" v-model="password" placeholder="6-16 digits Password, Case sensitive">
			</div>
			<div class="item">
				<input type="text" v-model="ensurePassword" placeholder="Confirm Password">
			</div>
		</div>
		<div class="submit" @click="submit">Reset Password</div>
		<div class="bottom_help flex align-center justify-center">
			<div><span>Contact : info@Curiouser-family.com </span> Telephone: +44 (0)7462258770</div>
			<!-- <div class="help">帮助</div> -->
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				codeStatus:false,
				codeNub:300,
				code:'',
				email:'',
				password:'',
				ensurePassword:'',
				sendStatus:false,
				submitStatus:false
			}
		},
		methods:{
			toHome(){
				this.$router.push('/home')
			},
			submit(){
				if(this.submitStatus){
					return
				}
				var params = {
					newpassword:this.password,
					email:this.email,
					code:this.code
				}
				if(!this.password){
					this.$message('Please enter a password')
					return
				}
				
				if(!this.code){
					this.$message('Please enter the 4 digit code that was sent to your email address')
					return
				}
				this.submitStatus = true
				this.$api.post('/user/resetpwd',params,res=>{
					if(res.code == 1){
						this.$message('Successful')
						// localStorage.setItem('token',res.data.token)
						setTimeout(()=>{
							this.$router.push('/home')
						},1000)
					}else{
						this.submitStatus = false
						this.$message(res.msg)
					}
				})
			},
			getCode(){
				var that = this;
				if(this.sendStatus){
					return;
				}
				this.sendStatus = true;
				var params = {
					event:'resetpwd',
					email:this.email
				}
				if(!this.email){
					this.$message('Please enter a valid email address');
					this.sendStatus = false;
					return;
				}
				this.$api.post('ems/send',params,res=>{
					if(res.code == 1){
						that.sendStatus = false;
						that.codeStatus = true;
						var codeTime = setInterval(function() {
							if (that.codeNub == 0) {
								clearInterval(codeTime)
								that.codeStatus = false
							} else {
								that.codeNub--
							}
						}, 1000)
					}else{
						this.sendStatus = false;
						this.$message(res.msg)
					}
				})
			}
		}
	}
</script>

<style scoped lang="scss">
	.forget{
		width: 100%;
		min-height: 100vh;
		background-color: #F7F2EB;
		padding-top: 70px;
		padding-bottom: 40px;
		.logo{
			width: 557px;
			height: 122px;
			margin: 0 auto;
			img{
				width: 100%;
				height: 100%;
			}
		}
		.first_title{
			font-size: 30px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #282E30;
			text-align: center;
			margin: 90px 0;
		}
		.content{
			width: 800px;
			margin: 0 auto;
			.item{
				width: 100%;
				height: 80px;
				border: 1px solid #282E30;
				border-radius: 10px;
				margin-top: 30px;
				padding-left: 30px;
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #999999;
				line-height: 80px;
				input{
					width: 100%;
					font-size: 20px;
					line-height: 40px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #999999;
				}
			}
			.code_box{
				width: 100%;
				margin-top: 30px;
				input{
					width: 580px;
					height: 80px;
					border: 1px solid #282E30;
					border-radius: 10px;
					margin-top: 30px;
					padding-left: 30px;
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #999999;
					line-height: 80px;
					margin-top: 0;
				}
				.code{
					width: 190px;
					height: 80px;
					background: #5C707A;
					border-radius: 10px;
					text-align: center;
					line-height: 80px;
					font-size: 24px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #F7F2EB;
					cursor: pointer;
				}
			}
		}
		.submit{
			width: 180px;
			height: 50px;
			background: #5C707A;
			border-radius: 29px;
			margin: 60px auto;
			line-height: 50px;
			text-align: center;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #F7F2EB;
			cursor: pointer;
		}
		.bottom_help{
			margin-top: 160rpx;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #282E30;
			span{
				margin-right: 50px;
			}
			.help{
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #5C707A;
				margin-left: 56rpx;
				cursor: pointer;
			}
		}
	}
</style>